import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
    standalone: true,
    selector: 'app-pencil-square-icon',
    templateUrl: 'pencil-square.component.html',
    imports: [CommonModule]
})
export class PencilSquareComponent {
    @Input()
    size: 'outline' | 'solid' | 'mini' | 'micro';

    @Input() strokeColor: string = 'currentColor';

    public getClasses() {
        return [this.getStrokeColor()];
    }

    private getStrokeColor(): string {
        return this.strokeColor;
    }
}
